const initialState = {
    isLoading:true,
    profiles:"",
  }
  export default initialState;